<template>
    <div class="definitions">
        <div v-if="definitionTag">

            <loading v-if="!definition"></loading>

            <div v-if="definition">
                <h1>{{ definition.title }}</h1>
                <div class="definitions-content" v-html="definition.content"></div>
            </div>

        </div>
    </div>
</template>


<script>
import api from 'js/api/resources'
import notify from 'js/components/notifications/notificationsMixin'
import { transform } from 'js/vuex/helpers'

import Loading from 'js/components/elements/Loading.vue'


export default {
    props: [],
    mixins: [ notify ],
    components: { Loading },
    vuex: {
        getters: {
            definitionTag: state => state.glossary.current,
        },
        actions: {
            addDefinitions: ({dispatch}, definitions) => dispatch('ADD_DEFINITIONS', definitions),
        }
    },
    mounted: function() {

        if ( this.definition == null ) {

            api.getDefinition(this.definitionTag)
                .then( response => transform(response.body))
                .then( (data) => {
                    this.addDefinitions(data.definitions)
                })
                .catch( () => {
                    this.$warn('Kan definitie niet vinden.')
                    this.close()
                })

        }

    },
    methods: {
        close: function() {
            this.$emit('close')
        }
    },
    computed: {
        definition: function() {
            return this.$store.state.glossary.storage[this.definitionTag]
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Glossary.vue?ef4dda64